// Scrolls to the target idRef with a small offset
const useSmoothScroll = (idRef, offset = 100) => {
    const ref = document.getElementById(idRef);

    if (offset === 0) {
        return ref.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    const elementPosition = ref.getBoundingClientRect().top;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
    });
};

export default useSmoothScroll;
